import { render, staticRenderFns } from "./SaveFormCreate.vue?vue&type=template&id=e81d7568"
import script from "./SaveFormCreate.vue?vue&type=script&lang=js"
export * from "./SaveFormCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports